// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__light--iCyId {
  --sys-color-primary: #f9fafa;
  --sys-color-secondary: #1aa6da;
  --sys-color-background: #f9fafa;
}
.style__dark--HldDA {
  --sys-color-primary: #313235;
  --sys-color-secondary: #1aa6da;
  --sys-color-background: #313235;
}
.style__app--N5ild {
  display: flex;
  background-color: var(--sys-color-background);
  height: 100%;
}
.style__main--t22oY {
  box-shadow: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-right: 2rem;
  overflow: hidden;
  padding-top: 3rem;
}
.style__box--ugVVB {
  border: 3px solid var(--sys-color-primary);
  border-radius: 1rem;
  padding: 1.5rem;
  background: #fff;
  margin: 2rem 0 2rem 2rem;
  height: 100%;
  overflow: auto;
}
.style__box--ugVVB > h5 {
  margin-top: 0;
}
.style__page--Y8ohX {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 3px solid var(--sys-color-primary);
  border-radius: 1rem;
  padding: 1.5rem;
  background: #fff;
  margin: 2rem 0 2rem 2rem;
  overflow: auto;
}
.style__page--Y8ohX > h5 {
  margin-top: 0;
}
.style__tableContainer--Eh7mb {
  overflow: auto;
  border-radius: 11px;
  border: 3px solid var(--sys-color-primary);
  padding: 1rem;
  background: #fff;
  margin: 1rem 0 2rem 2rem;
  height: 100%;
}
.style__flex--ayPsb {
  display: flex;
}
.style__actionBar--LTzje {
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
.style__pointer--ckb1o {
  cursor: pointer;
}
.style__iconRed--h2fqb {
  color: #d72a1d;
}
`, "",{"version":3,"sources":["webpack://./../components/src/theme.less","webpack://./src/style.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,8BAAA;EAEA,+BAAA;ACFF;ADKA;EACE,4BAAA;EACA,8BAAA;EAEA,+BAAA;ACJF;AALA;EAEI,aAAA;EACA,6CAAA;EACA,YAAA;AAMJ;AAVA;EAQI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAKJ;AApBA;EAmBI,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;AAIJ;AA7BA;EA4BM,aAAA;AAIN;AAhCA;EAgCI,YAAA;EACA,aAAA;EACA,sBAAA;EAEA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAEJ;AA3CA;EA4CM,aAAA;AAEN;AA9CA;EAiDI,cAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;AAAJ;AAvDA;EA2DI,aAAA;AADJ;AA1DA;EA+DI,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAFJ;AAlEA;EAwEI,eAAA;AAHJ;AArEA;EA4EI,cAAA;AAJJ","sourcesContent":["@import './colors';\n\n.light {\n  --sys-color-primary: @color-asphalt-grey-099;\n  --sys-color-secondary: @color-light-blue-060;\n\n  --sys-color-background: @color-asphalt-grey-099;\n}\n\n.dark {\n  --sys-color-primary: @color-asphalt-grey-020;\n  --sys-color-secondary: @color-light-blue-060;\n\n  --sys-color-background: @color-asphalt-grey-020;\n}\n","@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/theme';\n\n:local {\n  .app {\n    display: flex;\n    background-color: var(--sys-color-background);\n    height: 100%;\n  }\n\n  .main {\n    box-shadow: none;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    margin-right: @spacing-200;\n    overflow: hidden;\n    padding-top: @spacing-300;\n  }\n\n  .box {\n    border: 3px solid var(--sys-color-primary);\n    border-radius: @spacing-100;\n    padding: @spacing-150;\n    background: @color-white;\n    margin: @spacing-200 0 @spacing-200 @spacing-200;\n    height: 100%;\n    overflow: auto;\n\n    > h5 {\n      margin-top: 0;\n    }\n  }\n  .page {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    border: 3px solid var(--sys-color-primary);\n    border-radius: @spacing-100;\n    padding: @spacing-150;\n    background: @color-white;\n    margin: @spacing-200 0 @spacing-200 @spacing-200;\n    overflow: auto;\n\n    > h5 {\n      margin-top: 0;\n    }\n  }\n\n  .tableContainer {\n    overflow: auto;\n    border-radius: 11px;\n    border: 3px solid var(--sys-color-primary);\n    padding: @spacing-100;\n    background: @color-white;\n    margin: @spacing-100 0 @spacing-200 @spacing-200;\n    height: 100%;\n  }\n\n  .flex {\n    display: flex;\n  }\n\n  .actionBar {\n    display: flex;\n    gap: @spacing-100;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 1.25rem;\n  }\n\n  .pointer {\n    cursor: pointer;\n  }\n\n  .iconRed {\n    color: @color-red-050;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `style__light--iCyId`,
	"dark": `style__dark--HldDA`,
	"app": `style__app--N5ild`,
	"main": `style__main--t22oY`,
	"box": `style__box--ugVVB`,
	"page": `style__page--Y8ohX`,
	"tableContainer": `style__tableContainer--Eh7mb`,
	"flex": `style__flex--ayPsb`,
	"actionBar": `style__actionBar--LTzje`,
	"pointer": `style__pointer--ckb1o`,
	"iconRed": `style__iconRed--h2fqb`
};
export default ___CSS_LOADER_EXPORT___;
